/*
  Prepend an "Empty" entry to the specified array of options
*/
export function emptyOption(name = '(Empty)') {
  return { id: -1, name };
}

export default function prependEmptyOption(options: Array<object>) {
  return [emptyOption(), ...options]
}
